import { CMEExportContainer } from "@features/cme/containers/CMEExportContainer";
import { AppBar } from "@features/dashboard/layouts/AppBar";
import { handleNavigateBack } from "@helpers/common";
import DocumentTitle from "components/DocumentTitle";

const CMEExportRoute = () => {
	const title = "Export CME Certificate";

	return (
		<>
			<DocumentTitle title={title} />
			<AppBar title={title} onPressBack={() => handleNavigateBack("/cme")} />
			<CMEExportContainer />
		</>
	);
};

export default CMEExportRoute;
